import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { IsReadChange } from "../view/certify-card/constants/change-type";

export function useIsReadChange() {
  const { data, refetch } = useQuery<IsReadChange>(
    "/api/rendering/user/getIsReadChange"
  );
  const [isReadChange, setIsReadChange] = useState(IsReadChange.HaveRead);
  useEffect(() => {
    if (typeof data !== "number") return;
    setIsReadChange(data);
  }, [data]);

  return { isReadChange, isReadChangeRefetch: refetch };
}
